export default __webpack_public_path__ + "static/SVGTable02-87ea1515cd9f71da4749f808d564d686.svg";